// Shared notification read state using localStorage + custom events
const STORAGE_KEY = 'oval_read_notifications';
const UNREAD_COUNT_KEY = 'oval_unread_notif_count';

export const getReadIds = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch { return []; }
};

export const markAsRead = (id) => {
  const readIds = getReadIds();
  if (!readIds.includes(id)) {
    readIds.push(id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(readIds));
    // Dispatch event so other components (bell, sidebar) update
    window.dispatchEvent(new CustomEvent('notif-read-change'));
  }
};

export const markAllAsRead = (ids) => {
  const readIds = getReadIds();
  const newIds = ids.filter(id => !readIds.includes(id));
  if (newIds.length > 0) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...readIds, ...newIds]));
    window.dispatchEvent(new CustomEvent('notif-read-change'));
  }
};

export const isRead = (id) => getReadIds().includes(id);

// Set/get unread count in localStorage for cross-component sharing.
// It MUST outlive the tab: the count is written only by /notifications, so a
// session-scoped store pinned the bell dot and the sidebar NEW badge at 0 for any
// member who had not already opened the very page those indicators advertise.
// The `notif-read-change` event is what performs the cross-component sharing and
// is deliberately unchanged. (card 54174)
export const setUnreadCount = (count) => {
  localStorage.setItem(UNREAD_COUNT_KEY, String(count));
  window.dispatchEvent(new CustomEvent('notif-read-change'));
};

export const getUnreadCount = () =>
  parseInt(localStorage.getItem(UNREAD_COUNT_KEY) || '0', 10);
